<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Mission, Vision, Values and Strategy
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.mis"
            label="Mission and Vision"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="actions to deliver vision"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.val"
            label="Values"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="company values that guide all operations"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.stry"
            label="Strategy"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="company strategy"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        mis: "",
        val: "",
        stry: ""
      },
      orgForm: {
        mis: "",
        val: "",
        stry: ""
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.mis = this.getDetail.char.mis;
    this.localForm.val = this.getDetail.char.val;
    this.localForm.stry = this.getDetail.char.stry;
    this.orgForm.mis = this.getDetail.char.mis;
    this.orgForm.val = this.getDetail.char.val;
    this.orgForm.stry = this.getDetail.char.stry;
  },
  mixins: [docRevsModFunctions, ruleTextfield, apptheme],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar"]),
    userStatus() {
      let status = null;
      if (this.getDetail.basic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.mis !== this.orgForm.mis &&
        this.localForm.mis !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.mis = this.localForm.mis;
        // basic
        char.mis = this.localForm.mis;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.val !== this.orgForm.val &&
        this.localForm.val !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.val = this.localForm.val;
        // basic
        char.val = this.localForm.val;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.stry !== this.orgForm.stry &&
        this.localForm.stry !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.stry = this.localForm.stry;
        // basic
        char.stry = this.localForm.stry;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
